import { render, staticRenderFns } from "./Domain.vue?vue&type=template&id=5ab0dc6a&scoped=true&"
import script from "./Domain.vue?vue&type=script&lang=js&"
export * from "./Domain.vue?vue&type=script&lang=js&"
import style0 from "./Domain.vue?vue&type=style&index=0&id=5ab0dc6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab0dc6a",
  null
  
)

/* custom blocks */
import block0 from "./Domain.vue?vue&type=custom&index=0&blockType=i18n&lang=yml&locale=en"
if (typeof block0 === 'function') block0(component)
import block1 from "./Domain.vue?vue&type=custom&index=1&blockType=i18n&lang=yml&locale=ru"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol})
